// src/components/global-ui/GlobalToaster.tsx
import {useToast} from "@chakra-ui/react";
import {useEffect} from "react";
import useUiStore from "../../store/useUiStore.ts";

const GlobalToaster = () => {
  const toast = useToast();
  const {toast: toastState, hideToast} = useUiStore();

  useEffect(() => {
    if (toastState.isVisible) {
      toast({
        title: toastState.message,
        status: toastState.type,
        duration: 4000,
        isClosable: true,
        position: toastState.position,
        onCloseComplete: hideToast,
      });
    }
  }, [toastState, toast, hideToast]);

  return null;
};

export default GlobalToaster;